export default {"src":"/_next/static/media/ic-tab-green.07a65ad9.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};